import { APIService } from "services";

export const getVibhag = async (pageNo,pageSize,search) => {
    let res;
    if(search.length===0) {
        res = await getAllVibhag(pageNo,pageSize);
    }
    else{
        try {
            res = await searchVibhag(search,pageNo,pageSize);
        } catch(err) {
             return { records:[], totalCount:0 }
        }
    }
    if(res && res.data){
    return res.data;
    }else{
    return { records:[], totalCount:0 }
    }
    
}


export const addVibhag = (data) => {
return APIService.api().post(`/vibhag`,data)
}
export const updateVibhag = (vibhag_id,data) => {
return APIService.api().patch(`/vibhag/${vibhag_id}`,data)
}
export const getAllVibhag = (pageNo,pageSize) => {
return APIService.api().get(`/vibhag/?pageNo=${pageNo}&pageSize=${pageSize}`)
}
export const getOneVibhag = (vibhag_id) => {
return APIService.api().get(`/vibhag/${vibhag_id}`)
}
export const searchVibhag = (searchKey,pageNo,pageSize) => {
return APIService.api().get(`/vibhag/search/${searchKey}/?pageNo=${pageNo}&pageSize=${pageSize}`)
}
export const deleteVibhag = (vibhag_id) => {
return APIService.api().delete(`/vibhag/${vibhag_id}`)
}
